module.exports = __webpack_public_path__ + "img/mobile-banner-service-system.8de73a3f.png";